export default "__VITE_ASSET__CTS1k8pB__"